import React, { useState, useEffect } from 'react';
import useApi from '../../../../utils/api-manager/Helper/useApi';
import { BarChart } from '../../../common/ReusableComponent/Chart';

function SalesBarChart() {
  const [salesData, setSalesData] = useState([]);
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(false);
  const { Post } = useApi();
  const currentYear = new Date().getFullYear();

  const getMonthName = (monthString) => {
    const date = new Date(monthString);
    return date.toLocaleString('en-US', { month: 'short' });
  };

  const generateAllMonthsArray = (year) => {
    return Array.from({ length: 12 }, (_, i) => {
      return `${year}-${String(i + 1).padStart(2, '0')}`;
    });
  };

  useEffect(() => {
    const fetchMonthlySales = async () => {
      try {
        setLoading(true);
        const response = await Post('monthlySales', {
          start_date: `${currentYear}-01-01`,
          end_date: `${currentYear}-12-31`,
        });

        const apiData = response.data;
        const monthsArray = generateAllMonthsArray(currentYear);
        const salesArray = monthsArray.map((month) => {
          const match = apiData.find(item => item.month === month);
          return match ? match.total_sales : 0;
        });

        setMonths(monthsArray.map(getMonthName));
        setSalesData(salesArray);
        
        // Check if there's any actual sales data (non-zero values)
        setHasData(salesArray.some(sale => sale > 0));
      } catch (err) {
        console.error('Error fetching sales data', err);
        setSalesData([]);
        setMonths([]);
        setHasData(false);
      } finally {
        setLoading(false);
      }
    };

    fetchMonthlySales();
  }, []);

  const chartDatasets = [
    {
      label: 'Sales This Year',
      data: salesData,
    },
  ];

  return (
    <div style={{ width: '640px', height: '300px', padding: '2px', marginBottom: '40px', marginLeft: '25px' }}>
      {loading ? (
        <p style={{
          fontSize: '16px',
          color: '#999',
          marginTop: '20%',
          textAlign: 'center',
          fontStyle: 'italic',
        }}>Loading...</p>
      ) : hasData ? (
        <BarChart
          labels={months}
          datasets={chartDatasets}
          title={`Sales for ${currentYear}`}
          theme="custom"
          height="290px"
          width="570px"
          noBorder
          noShodow
        />
      ) : (
        <p style={{
          fontSize: '16px',
          color: '#999',
          marginTop: '20%',
          textAlign: 'center',
          fontStyle: 'italic',
        }}>No data available</p>
      )}
    </div>
  );
}

export default SalesBarChart;